/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { canistersListCanistersApiV1LedgersLedgerCanisterIdCanistersGet } from "../../funcs/canistersListCanistersApiV1LedgersLedgerCanisterIdCanistersGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest$inboundSchema,
};

export const tool$canistersListCanistersApiV1LedgersLedgerCanisterIdCanistersGet:
  ToolDefinition<typeof args> = {
    name: "canisters-list-v1",
    description: `Original tool name: canisters-list-canisters-api-v1-ledgers-ledger-canister-id-canisters-get

List canisters`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await canistersListCanistersApiV1LedgersLedgerCanisterIdCanistersGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };